import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import TooltipItem from "../common/TooltipItem";
import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import { openChatBar } from "../../actions/mqttAction";

class Sidebar extends Component {
  constructor() {
    super();
    this.toggle = this.toggle.bind(this);

    this.state = {
      activeTab: "",
      tooltipOpen: false,
      openChat: false
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }
  lockScreen() {}
  openChat() {
    let chatState = this.state.openChat;
    this.setState({ ...this.state, openChat: !chatState });
    this.props.openChatBar(!chatState);
  }

  render() {
    const { roles, isAdmin } = this.props.auth.user;
    let accessRole = roles[0];

    return (
      <div>
        <div id="sidebar-wrapper">
          <div id="left-dock">
            <Nav className="nav-stacked">
              {isAdmin && (
                <NavItem
                  className={classnames({
                    active: this.state.activeTab === "1"
                  })}
                  onClick={() => {
                    this.toggle("1");
                  }}
                >
                  <NavLink
                    id="tooltip1"
                    tag={Link}
                    to="/dashboard2"
                    className="nav-color"
                  >
                    <i className="fas fa-shield-alt fa-lg" />
                  </NavLink>
                  <TooltipItem
                    tooltipText="Admin Dashboard"
                    target="tooltip1"
                    placement="right"
                  />
                </NavItem>
              )}
              {accessRole === "PHARMACIST" ? (
                <NavItem
                  className={classnames({
                    active: this.state.activeTab === "2"
                  })}
                  onClick={() => {
                    this.toggle("2");
                  }}
                >
                  <NavLink
                    id="tooltip2"
                    tag={Link}
                    to="/pharmacist-dashboard"
                    className="nav-color"
                  >
                    <i className="fab fa-medrt fa-lg" />
                  </NavLink>
                  <TooltipItem
                    tooltipText="Pharmacist Dashboard"
                    target="tooltip2"
                    placement="right"
                  />
                </NavItem>
              ) : (
                <NavItem
                  className={classnames({
                    active: this.state.activeTab === "3"
                  })}
                  onClick={() => {
                    this.toggle("3");
                  }}
                >
                  <NavLink
                    id="tooltip3"
                    tag={Link}
                    to="/pharmacist-dashboard"
                    className="nav-color"
                  >
                    <i className="far fa-user fa-lg mr-2" />
                  </NavLink>
                  <TooltipItem
                    tooltipText="Technician Dashboard"
                    target="tooltip3"
                    placement="right"
                  />
                </NavItem>
              )}
              <NavItem
                className={classnames({ active: this.state.activeTab === "4" })}
                onClick={() => {
                  this.toggle("4");
                }}
              >
                <NavLink
                  id="tooltip4"
                  onClick={() => {
                    this.openChat();
                  }}
                  className="nav-color"
                >
                  <i
                    className="far fa-comments fa-lg mr-2"
                    onClick={() => {
                      this.openChat();
                    }}
                  />
                </NavLink>
                <TooltipItem
                  tooltipText="Chat"
                  target="tooltip4"
                  placement="right"
                />
              </NavItem>
              <NavItem
                className={classnames({ active: this.state.activeTab === "5" })}
                onClick={() => {
                  this.lockScreen();
                }}
              >
                <NavLink id="tooltip5">
                  <i className="fas fa-lock fa-lg mr-2"></i>
                </NavLink>
                <TooltipItem
                  tooltipText="Lock Screen"
                  target="tooltip5"
                  placement="right"
                />
              </NavItem>
            </Nav>
          </div>
        </div>
      </div>
    );
  }
}

Sidebar.propTypes = {
  auth: PropTypes.object.isRequired,
  openChatBar: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, { openChatBar })(Sidebar);
